function updateNotificationsCounter(notifications, all) { 

  // var nots = all ? parseInt(notifications) : parseInt($('#notificationsBadge').html()) + (parseInt(notifications)); 

  // if (nots <= 0) {
  //   $('#notificationCounter').hide();
  // }
  // else {
  //   $('#notificationCounter').show();
  // }

  // $('#notificationsBadge').html(nots);

  var notificationBadge = document.getElementById('notificationsBadge');
  var notificationCounter = document.getElementById('notificationCounter');
  var nots = all ? parseInt(notifications) : parseInt(notificationsBadge).html() + (parseInt(notifications)); 

  if (nots <= 0) {
    notificationCounter.hide();
  }
  else {
    notificationCounter.show();
  }

  notificationsBadge.html(nots);

} 
